import { createFileRoute, notFound } from "@tanstack/react-router";
import { MarketingIdeasPage } from "../components/marketing/MarketingIdeasPage";
import { findIdeaHub, ideaHubPage } from "../marketing-content/automationIdeaHubs";
import { contentHead } from "../marketing-content/head";

export const Route = createFileRoute("/workflows_/tool/$tool")({
  loader: async ({ params }) => {
    const hub = findIdeaHub("tool", params.tool);
    if (!hub) throw notFound();
    // Integration data is large; only tool pages need it, for one link.
    const { integrationForTool } = await import("../marketing-content/integrations");
    return { hub, integrationSlug: integrationForTool(hub.value)?.slug };
  },
  head: ({ loaderData }) => contentHead(loaderData && ideaHubPage(loaderData.hub)),
  component: HubRoute,
});

function HubRoute() {
  const { hub, integrationSlug } = Route.useLoaderData();
  return <MarketingIdeasPage hub={hub} integrationSlug={integrationSlug} key={hub.slug} />;
}
